import { NavigateFunction } from "react-router-dom";
import { useMemo } from "react";
import { useUser } from "hooks/use-user";

/**
 * Central dashboard configuration
 * If role is undefined → visible to ALL users
 */
const ALL_DASHBOARD_OPTIONS = [
  {
    label: "MIS – Command Centre Dashboard",
    route: "/dashboard",
    role: undefined,
  },
  {
    label: "SLA Performance Dashboard",
    route: "/slaDashboard",
    role: "PC SMT Board",
  },
  {
    label: "RM – SLA Performance Dashboard",
    route: "/rmSlaDashboard",
    role: "PC RM Board",
  },
  {
    label: "FLM Dispatcher Performance Dashboard",
    route: "/flmDispatcherDashboard",
    role: "PC FLM Board",
  },
  {
    label: "SLM Dispatcher Performance Dashboard",
    route: "/slmDispatcherDashboard",
    role: "PC SLM Board",
  },
];

/**
 * Hook: Returns dashboards allowed for logged-in user
 */
export const useDashboardOptions = () => {
  const user = useUser() as { Roles?: string[] | string } | null;

  return useMemo(() => {
    let roles: string[] = [];

    if (Array.isArray(user?.Roles)) {
      roles = user!.Roles;
    } else if (typeof user?.Roles === "string") {
      // In case backend sends comma-separated roles
      roles = user.Roles.split(",");
    }

    // Normalize roles safely
    const normalizedRoles = roles.map((r) => r.toLowerCase().trim());

    return ALL_DASHBOARD_OPTIONS.filter((dashboard) => {
      // Always include dashboards without role
      if (!dashboard.role) return true;

      return normalizedRoles.includes(dashboard.role.toLowerCase().trim());
    });
  }, [user]);
};

/**
 * Navigation helper
 */
export const handleDashboardNavigation = (
  value: string,
  navigate: NavigateFunction,
  dashboardOptions: { label: string; route: string }[],
) => {
  const selected = dashboardOptions.find((d) => d.label === value);

  if (selected?.route) {
    navigate(selected.route);
  }
};
